import { useState } from "react";

export const useToggleAll = (initialState: boolean = false) => {
  const [allToggled, setAllToggled] = useState(initialState);

  const handleToggleAll = () => {
    setAllToggled((prev) => !prev);
  };

  return {
    allToggled,
    handleToggleAll,
  };
};
